import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	cta: {
		id: 'subpage.unlock.cta',
		defaultMessage: 'Unlock more free content',
		description: 'Button text for sending user to sign up flow',
	},
	ctaLoggedInIneligible: {
		id: 'subpage.unlock.ctaLoggedInIneligible',
		defaultMessage: 'Subscribe to Calm',
		description: 'Button text for sending inteligible user to subscribe flow',
	},
	ctaActiveSub: {
		id: 'subpage.unlock.ctaActiveSub',
		defaultMessage: 'Continue to App',
		description: 'Button text for sending active subscriber to app',
	},
});
